export default __webpack_public_path__ + "static/slice-social-share-5cd9122f1f7bd7aa28b43ed5d475b5c5.png";